import { useState, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ROUTE_EDIT_ADJUSTMENTS } from '../routes/Routes';
import ApprovalSingleSelectDevEx from './components/ApprovalSingleSelectDevEx';
import PutPostPatchFetch from '../hooks/PutPostPatchFetch';
import { LoadingIndicatorCircle } from "../components/Loading";
import { useAuth } from "../hooks/useAuth";
import BaseNotification from '../components/BaseNotification/BaseNotification';


const FYCostsTableModifiers = ({ selectedRowKey, roleAllowApprove, roleAllowEdit, /*roleAllowDeactivate,*/ rowSelected, onApprovalChange, /*onActivationChange*/ }) => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState()
    const [allowEditing, setAllowEdit] = useState(false);
    const [allowApprove, setAllowApprove] = useState(false);
    const [selectedBuildingNumber, setSelectedBuildingNumber] = useState(undefined);
    const [approvalOptions, setApprovalOptions] = useState(['Submitted', 'Approved', 'Denied']);
    const [notification, setNotification] = useState({
        message: '',
        type: undefined,
        visible: false
    });

    useEffect(() => {
        handlePermissionsChanges(selectedRowKey)
        setSelectedBuildingNumber(selectedRowKey?.buildingSequenceNo);
    }, [selectedRowKey])

    const handleEditAdjustment = () => {
        var selectedRowData = selectedRowKey
        navigate(ROUTE_EDIT_ADJUSTMENTS.withSlash, {
            state: { selectedRowData }
        });
    }

    const handlePermissionsChanges = (selected) => {
        let deactivated = selected?.IsInactive;
        if (!deactivated) {
            switch (selected?.approvalStatus) {
                case 'Approved': // Logic for approved Adjustments: NO edit, NO approval change, NO Deactivate
                    setAllowApprove(false);
                    //setAllowDeactivate(false);
                    setAllowEdit(false);
                    setApprovalOptions(['Approved'])
                    break;
                case 'Denied': // Logic for denied Adjustments: YES Edit, Approvers and Deactivators can change back to submitted, YES Deactivate/Reactivate
                    setAllowApprove(roleAllowApprove /*|| roleAllowDeactivate*/)
                    setAllowEdit(roleAllowEdit)
                    //setAllowDeactivate(roleAllowDeactivate)
                    setApprovalOptions(['Submitted', 'Denied'])
                    break;
                case 'Submitted': // Logic for submitted. YES Edit, YES Approval Change Allowed, YES Deactivate/Reactivate
                    setAllowApprove(roleAllowApprove /*|| roleAllowDeactivate*/)
                    setAllowEdit(roleAllowEdit)
                    //setAllowDeactivate(roleAllowDeactivate)
                    if (roleAllowApprove) setApprovalOptions(['Submitted', 'Approved', 'Denied'])
                    else setApprovalOptions(['Submitted', 'Denied'])
                    break;
                case 'Pending': // Logic for submitted. YES Edit, YES Approval Change Allowed, YES Deactivate/Reactivate
                    setAllowApprove(roleAllowApprove /*|| roleAllowDeactivate*/)
                    setAllowEdit(roleAllowEdit)
                    //setAllowDeactivate(roleAllowDeactivate)
                    if (roleAllowApprove) setApprovalOptions(['Submitted', 'Approved', 'Denied'])
                    else setApprovalOptions(['Submitted', 'Denied'])
                    break;
                default:
                    setAllowApprove(false)
                    //setAllowDeactivate(false)
                    setAllowEdit(false)
                    setApprovalOptions([])
                    break;
            }
        }
        else {
            // Logic for Deactivated. NO Edit, NO Approval Change allowed (reactivate will set status to "Submitted"), YES reactivate for Approvers or Deactivators
            setAllowApprove(false);
            setAllowEdit(false);
            //setAllowDeactivate(roleAllowApprove || roleAllowDeactivate);
            setApprovalOptions([])
        }
    }

    const handleApprovalChangeClick = async (value) => {
        setLoading(true)
        var editedAdjustment = {
            SecurityCostId: selectedRowKey.id,
            ApprovalStatus: value,
            UserAccount: user.email
        }
        const { Success, Errors } = await PutPostPatchFetch('/v1/SecurityCostBatch/ChangeApproval', 'PUT', editedAdjustment);

        if (Success) {
            setNotification({
                message: `Approval status: ${value} (Cost Estimate was updated successfully)`,
                type: 'success',
                visible: true
            });
            onApprovalChange(value)
            
            const tempNewKey = selectedRowKey;
            tempNewKey.ApprovalStatus = editedAdjustment.ApprovalStatus
            handlePermissionsChanges(tempNewKey)
        }
        if (Errors.length > 0) {
            setNotification({
                message: Errors[0].Message || "Something went wrong... Please correct your inputs and try again.",
                type: 'error',
                visible: true
            });
        };
    }

    
    return (
        <div>
            <Box sx={{ height: 100, width: '97%', margin: 'auto auto 0 auto' }}>
                {selectedRowKey && !loading &&
                    <>
                    {
                        //allowDeactivate &&
                        //    <Button
                        //        sx={{ mt: 1, ml: 1, pl: 1 }}
                        //        aria-disabled={!rowSelected}
                        //        disabled={!rowSelected}
                        //        onClick={handleActivationChangeClick}
                        //        variant={outlined}
                        //    >
                        //        {deactivateButtonLabel}
                        //    </Button>
                        }
                        {allowApprove &&
                            <ApprovalSingleSelectDevEx
                                approvalOptions={approvalOptions}
                                approvalAllowed={allowApprove}
                                customLabel={selectedBuildingNumber}
                                selectedAdjustment={selectedRowKey}
                                handleSubmit={handleApprovalChangeClick}
                            />
                        }
                    </>
                }
                {loading &&
                    <LoadingIndicatorCircle message="Submitting changes, please wait ..." />
                    }
            </Box>
            <BaseNotification 
                message={notification.message}
                ref={useRef(null)}
                setter={() => setNotification(() => (
                    { 
                        isVisible: false,
                        message: '',
                        type: undefined
                    }
                ))}
                type={notification.type}
                visible={notification.visible}
            />
        </div>
    )
};


export default FYCostsTableModifiers;